import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const Isabell60 = () => (
  <ArticleWrapper articleId="isabell60">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>Isabell60</h1>
        <img src="/pictures/gallery/gallery3.JPG" alt="Isabell60" className="rounded-lg mb-6" />
        {/* Add your Isabell60 article content here */}
      </div>
    </div>
  </ArticleWrapper>
);

export default Isabell60;
